<template>
    <div class="animated fadeIn">
        <b-row>
            <b-col lg="12">
                <b-card>
                    <div slot="header">
                        <strong>Thêm mới bài viết</strong>
                    </div>
                    <b-form @submit.prevent="save">
                        <b-row>
                            <b-col>
                                <b-form-group label="Thể loại bài viết:"
                                              label-for="blogCategoryIds"
                                              :label-cols="2"
                                              :horizontal="true"
                                              label-align="right">
                                    <!--<b-form-input type="text" id="blogCategoryIds"
                                                  class="col-10"
                                                  aria-describedby="codeFeedback"
                                                  v-model="$v.blog.title.$model"
                                                  :state="$v.blog.title.$dirty? !$v.blog.title.$error : null">
                                    </b-form-input>-->
                                    <select2 class="no-padding col-10" 
                                             v-model="blog.blogCategoryIds"
                                             v-if="blogCategories.length > 0"
                                             :options="blogCategories"
                                             allowClear="true"
                                             multiple="true"
                                             placeholder="--- Chọn ---"></select2>
                                    <b-form-invalid-feedback id="codeFeedback">
                                        Vui lòng nhập tiêu đề bài viết
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                        </b-row>

                        <b-row>
                            <b-col>
                                <b-form-group label="Thẻ bài viết:"
                                              label-for="tagIds"
                                              :label-cols="2"
                                              :horizontal="true"
                                              label-align="right">
                                    <!--<b-form-input type="text" id="blogCategoryIds"
                                                  class="col-10"
                                                  aria-describedby="codeFeedback"
                                                  v-model="$v.blog.title.$model"
                                                  :state="$v.blog.title.$dirty? !$v.blog.title.$error : null">
                                    </b-form-input>-->
                                    <select2 class="no-padding col-10" 
                                             v-model="blog.tagIds"
                                             v-if="tags.length > 0"
                                             :options="tags"
                                             allowClear="true"
                                             multiple="true"
                                             placeholder="--- Chọn ---"></select2>
                                    
                                </b-form-group>
                            </b-col>
                        </b-row>

                        <b-row>
                            <b-col>
                                <b-form-group label="Tiêu đề bài viết:"
                                              label-for="name"
                                              :label-cols="2"
                                              :horizontal="true"
                                              label-align="right"
                                              label-class="required">
                                    <b-form-input type="text" id="title"
                                                  class="col-10"
                                                  aria-describedby="codeFeedback"
                                                  v-model="$v.blog.title.$model"
                                                  :state="$v.blog.title.$dirty? !$v.blog.title.$error : null">
                                    </b-form-input>
                                    <b-form-invalid-feedback id="codeFeedback">
                                        Vui lòng nhập tiêu đề bài viết
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <b-form-group label="Tiêu đề không dấu:"
                                              title="phục vụ đường link"
                                              label-for="slug"
                                              :label-cols="2"
                                              :horizontal="true"
                                              label-align="right">
                                    <b-form-input type="text" id="slug"
                                                  class="col-10"
                                                  aria-describedby="codeFeedback"
                                                  v-model="blog.slug">
                                    </b-form-input>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <b-form-group label="Mô tả:"
                                              label-for="name"
                                              :label-cols="2"
                                              label-align="right"
                                              :horizontal="true"
                                              label-class="required">
                                    <b-form-textarea v-model="$v.blog.description.$model"
                                                     :state="$v.blog.description.$dirty ? !$v.blog.description.$error : null"
                                                     class="col-10" id="description" rows="3"></b-form-textarea>
                                    <b-form-invalid-feedback v-if="!$v.blog.description.required && $v.blog.description.maxLength">
                                        Vui lòng nhập mô tả bài viết
                                    </b-form-invalid-feedback>
                                    <b-form-invalid-feedback v-if="!$v.blog.description.maxLength">
                                        Không được quá 256 ký tự !
                                    </b-form-invalid-feedback>
                                </b-form-group>

                            </b-col>
                        </b-row>

                        <b-row>
                            <b-col>
                                <b-form-group label="Chi tiết:"
                                              label-for="name"
                                              :label-cols="2"
                                              label-align="right"
                                              :horizontal="true"
                                              id="editor-css">
                                    <b-col md="10" class="no-padding">
                                        <b-form-input type="text"
                                                      style="display:none;"
                                                      aria-describedby="codeFeedback"
                                                      v-model="$v.blog.detail.$model"
                                                      :state="$v.blog.detail.$dirty? !$v.blog.detail.$error : null">
                                        </b-form-input>
                                        <DocumentEditor ref="doc" v-model="blog.detail"></DocumentEditor>
                                        <b-form-invalid-feedback v-if="!$v.blog.detail.required">
                                            Vui lòng nhập chi tiết !
                                        </b-form-invalid-feedback>
                                    </b-col>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <b-form-group label="Tệp đính kèm:"
                                              label-for="file"
                                              :label-cols="2"
                                              label-align="right"
                                              :horizontal="true">
                                    <b-form-file v-model="blog.file"
                                                 class="col-10 no-padding"
                                                  accept="image/*"
                                                 browse-text="Chọn"
                                                 placeholder="Chọn tệp tải lên..."></b-form-file>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <b-form-group label="MetaTitle:"
                                              label-for="name"
                                              :label-cols="2"
                                              label-align="right"
                                              :horizontal="true">
                                    <b-form-textarea v-model="$v.blog.metaTitle.$model"
                                                     :state=" $v.blog.metaTitle.$model && $v.blog.metaTitle.$dirty ? !$v.blog.metaTitle.$error : null"
                                                     class="col-10" id="MetaTitle" rows="3"></b-form-textarea>
                                    <b-form-invalid-feedback v-if="!$v.blog.metaTitle.maxLength">
                                        Không được quá 256 ký tự !
                                    </b-form-invalid-feedback>
                                </b-form-group>

                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <b-form-group label="MetaKeywords:"
                                              label-for="MetaKeywords"
                                              :label-cols="2"
                                              label-align="right"
                                              :horizontal="true">
                                    <b-form-textarea v-model="$v.blog.metaKeywords.$model"
                                                     :state="$v.blog.metaKeywords.$model && $v.blog.metaKeywords.$dirty ? !$v.blog.metaKeywords.$error : null"
                                                     class="col-10" id="MetaKeywords" rows="3"></b-form-textarea>
                                    <b-form-invalid-feedback v-if="!$v.blog.metaKeywords.maxLength">
                                        Không được quá 256 ký tự !
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <b-form-group label="MetaDescriptions:"
                                              label-for="MetaDescriptions"
                                              :label-cols="2"
                                              label-align="right"
                                              :horizontal="true">
                                    <b-form-textarea v-model="$v.blog.metaDescriptions.$model"
                                                     :state=" $v.blog.metaDescriptions.$model && $v.blog.metaDescriptions.$dirty ? !$v.blog.metaDescriptions.$error : null"
                                                     class="col-10" id="MetaDescriptions" rows="3"></b-form-textarea>
                                    <b-form-invalid-feedback v-if="!$v.blog.metaDescriptions.maxLength">
                                        Không được quá 256 ký tự !
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                        </b-row>

                        <b-row>
                            <b-col>
                                <b-form-group label="Trạng thái:"
                                              label-align="right"
                                              label-for="status"
                                              :label-cols="2"
                                              :horizontal="true">
                                    <b-form-checkbox id="status" v-model="blog.status" class="col-8 col-form-label"></b-form-checkbox>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <b-form-group label="" :label-cols="2">
                                    <b-button v-if="authorize(['ManageBlog'])" type="submit" variant="primary">Ghi lại</b-button>
                                    <b-button type="button" variant="secondary" @click="cancel">Hủy</b-button>
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </b-form>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>
<script>
    import { mapState } from 'vuex'
    import { validationMixin } from 'vuelidate'
    import { authorizationMixin } from '@/shared/mixins'
    import { required, sameAs, minLength, maxLength, helpers } from 'vuelidate/lib/validators'

    export default {
        name: 'CreateBlog',
        mixins: [validationMixin, authorizationMixin],
        data() {
            return {
                blog: {
                    id: 0,
                    title: null,
                    description: null,
                    urlImage: null,
                    detail: null,
                    blogCategoryIds: [],
                    metaTitle: null,
                    metaKeywords: null,
                    metaDescriptions: null,
                    status: false,
                    slug: null,
                    file: null
                },
                editing: false,
            }
        },
        computed: {
            ...mapState({
                blogCategories: (state, getters) => state.common.blogCategories,
                tags: (state, getters) => state.common.tags,
            })
        },
        validations: {
            blog: {
                title: {
                    required,
                    maxLength: maxLength(128)
                },
                description: {
                    required,
                    maxLength: maxLength(256)

                },
                detail: {
                    required,

                },
                metaTitle: {
                    maxLength: maxLength(256)
                },
                metaKeywords: {
                    maxLength: maxLength(256)
                },
                metaDescriptions: {
                    maxLength: maxLength(256)
                },
                //seoTitle: {
                //    maxLength: maxLength(256)
                //},
            },
        },
        watch: {
            //'blog.code'(newVal) {
            //    this.checkExistCode(newVal);
            //}
            'blog.urlImage'(file) {
                //this.url = URL.createObjectURL(file);

            },
            'blog.title'(value) {
                this.blog.slug = value.convertslug();
            }
        },
        created() {

            //var token = JSON.parse(localStorage.getItem("_accessToken")).access_token;
            //console.log('Bearer ' + JSON.parse(localStorage.getItem("_accessToken")).access_token);
            //this.$nextTick(function () {
            //    $('textarea.editor').each(function () {

            //        var editor = CKEDITOR.replace(this.id);;
            //        //CKFinder.setupCKEditor(editor);
            //    });
            //});
        },
        mounted(){
            const element = document.getElementById("editor-css");
            element.querySelector(".bv-no-focus-ring").classList.add("col-md-10");
        },
        methods: {
            cancel() {
                this.$router.push({ path: '/master-data/blogs/list' });
            },
            save() {
                this.$v.$touch();
                if (!this.$v.$invalid) {
                    var vm = this;
                    //this.blog.detail = this.$refs.doc.editorData;
                    this.$services.upload('master-data/blogs', this.blog).done((id) => {
                        vm.$toastr.s('Tạo mới bài viết thành công');
                        vm.cancel();
                    });
                }
            },
            //checkExistCode(newVal) {
            //    if (newVal) {
            //        //var vm = this;
            //        //this.$services.get(`master-data/existing-unit-types-code/${newVal}/${this.blog.id || null}`).done(returnData => {
            //        //    if (!returnData) {
            //        //        this.codeUnique = "required";
            //        //    }
            //        //    else {
            //        //        this.codeUnique = "";
            //        //    }
            //        //});
            //    }
            //    else {
            //        this.codeUnique = "required";
            //    }
            //}
        }
    }

</script>
<style>
    /*  .ck-editor__editable {
        min-height: 500px;
    }*/
    .ck-editor .ck-editor__main .ck-content {
        min-height: 200px;
    }

    .ck-editor__editable_inline {
        min-height: 200px;
    }
</style>
